import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Frequently Asked Questions | ShipSticks',
  description:
    'Get quick answers to the most frequently asked questions about ShipSticks. ' +
    'Learn how it works, what you can ship, international guidelines, and more.',
  alternates: {
    canonical: 'https://www.shipsticks.com/faq',
  },
}

export default metadata
